import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
// import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import "./Reports.css"
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1910() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    const [Borrow1910data, setBorrow1910data] = useState([]);

    /*async function GetV1910() {
        const response1910 = await fetch("/api/BorrowReports/getV1910")
        const Borrow1910data = await response1910.json()
        setBorrow1910data(Borrow1910data.dataenum);
        // console.log(Borrow1910data)
    }*/

    const [thMonthSelected, setThMonthSelected] = React.useState(new Date().getMonth()+1)

    async function GetV1910() {
        const formData = new FormData();
        formData.append("thMonth", thMonthSelected);
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV1910", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow1910data(data.dataenum)

    }
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear())
    const [Re1910yeardata, setRe1910yeardata] = React.useState([]);

    async function getR1910year() {
        const res = await fetch("/api/BorrowReports/getyear1910")
        const Re1910yeardata = await res.json()
        setRe1910yeardata(Re1910yeardata.dataenum)
        // console.log(Re1910yeardata)
    }

    let monthTh = "";
    if (thMonthSelected === 1) {
        monthTh = "มกราคม";
    }
    if (thMonthSelected === 2) {
        monthTh = "กุมภาพันธ์";
    }
    if (thMonthSelected === 3) {
        monthTh = "มีนาคม";
    }
    if (thMonthSelected === 4) {
        monthTh = "เมษายน";
    }
    if (thMonthSelected === 5) {
        monthTh = "พฤษภาคม";
    }
    if (thMonthSelected === 6) {
        monthTh = "มิถุมายน";
    }
    if (thMonthSelected === 7) {
        monthTh = "กรกฎาคม";
    }
    if (thMonthSelected === 8) {
        monthTh = "สิงหาคม";
    }
    if (thMonthSelected === 9) {
        monthTh = "กันยายน";
    }
    if (thMonthSelected === 10) {
        monthTh = "ตุลาคม";
    }
    if (thMonthSelected === 11) {
        monthTh = "พฤศจิกายน";
    }
    if (thMonthSelected === 12) {
        monthTh = "ธันวาคม";
    }

    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ลำดับ', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ผู้กู้ยืม', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'วงเงินกู้ยืม', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'อัตราดอกเบี้ย', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ผ่อนชำระ (งวด)', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'งวดละ (บาท)', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'วันที่เริ่มชำระ', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ผ่อนผัน (6 เดือน)', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'สิ้นสุดชำระ', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวนเงินชำระคืน', colSpan: 5, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, {}, {}, { text: 'ค้านชำระ เดือน มี.ค. 2564', colSpan: 4, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, {}, { text: 'เงินต้นคงเหลือ', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'หน่วยงานที่ทำสัญญา', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }],
    //     [{}, {}, {}, {}, {}, {}, {}, {}, {}, { text: 'จำนวน (งวด)', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวน (เงิน)', colSpan: 4, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, {}, { text: 'จำนวน (งวด)', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวน (เงิน)', colSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, {}, {}],
    //     [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, { text: 'เงินต้น', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ดอกเบี้ย', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'รวม', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'วันที่ชำระครั้งสุดท้าย', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, { text: 'เงินต้น', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ดอกเบี้ย', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'รวม', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}]];
    //     Borrow1910data.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.employee, alignment: 'left' }, { text: item.amountLimit, alignment: 'right' }, { text: item.interest, alignment: 'right' }, { text: item.installment, alignment: 'right' }, { text: item.installmentAmount, alignment: 'right' }, { text: item.firstPaymentDate, alignment: 'right' }, { text: item.lenient, alignment: 'right' }, { text: item.typeLastPayment, alignment: 'right' }, { text: item.paymentAmount, alignment: 'right' }, { text: item.repayPrincipal, alignment: 'right' }, { text: item.repayInterest, alignment: 'right' }, { text: item.totalRepay, alignment: 'right' }, { text: item.lastPaymentDate, alignment: 'right' }, { text: item.overdueAmount, alignment: 'right' }, { text: item.overduePrincipal, alignment: 'right' }, { text: item.overdueInterest, alignment: 'right' }, { text: item.totalOverdue, alignment: 'right' }, { text: item.totalPrincipal, alignment: 'right' }, { text: item.site, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'ตารางสรุปการค้างชำระเงินกู้ยืมคืน ค้างชำระเดือน' + ' ' +  monthTh, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: [15, 20, 'auto', 20, 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 50, 50],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1910')
    // }

    useEffect(() => {
        GetV1910()
        getR1910year()
    }, [thMonthSelected],[thYearSelected])
    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='mt-3 text-center'>
                        ค้างชำระเดือน
                    </h3>
                    <Input
                        style={{ borderColor: "#FFFFFF", width: "15%", paddingTop: '10px', fontSize: '1.75rem' }}
                        id="thMonth"
                        name="thMonth"
                        type="select"
                        value={thMonthSelected}
                        onChange={(e) => {
                            setThMonthSelected(e.target.value)
                        }}
                    >
                        <option value={1}>
                            มกราคม
                        </option>
                        <option value={2}>
                            กุมภาพันธ์
                        </option>
                        <option value={3}>
                            มีนาคม
                        </option>
                        <option value={4}>
                            เมษายน
                        </option>
                        <option value={5}>
                            พฤษภาคม
                        </option>
                        <option value={6}>
                            มิถุมายน
                        </option>
                        <option value={7}>
                            กรกฎาคม
                        </option>
                        <option value={8}>
                            สิงหาคม
                        </option>
                        <option value={9}>
                            กันยายน
                        </option>
                        <option value={10}>
                            ตุลาคม
                        </option>
                        <option value={11}>
                            พฤศจิกายน
                        </option>
                        <option value={12}>
                            ธันวาคม
                        </option>
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center w-100'>
                    <div className='d-flex justify-content-center align-items-center w-50'>
                        <span className='header-select-year mx-3'>ค้างชำระเดือน</span>
                        <Input
                            // className='report-select-one-year'
                            className="rounded-pill input-color w-25 text-center"
                            id="thMonth"
                            name="thMonth"
                            type="select"
                            value={thMonthSelected}
                            onChange={(e) => {
                                setThMonthSelected(e.target.value)
                            }}
                        >
                            <option value={1}>
                                มกราคม
                            </option>
                            <option value={2}>
                                กุมภาพันธ์
                            </option>
                            <option value={3}>
                                มีนาคม
                            </option>
                            <option value={4}>
                                เมษายน
                            </option>
                            <option value={5}>
                                พฤษภาคม
                            </option>
                            <option value={6}>
                                มิถุมายน
                            </option>
                            <option value={7}>
                                กรกฎาคม
                            </option>
                            <option value={8}>
                                สิงหาคม
                            </option>
                            <option value={9}>
                                กันยายน
                            </option>
                            <option value={10}>
                                ตุลาคม
                            </option>
                            <option value={11}>
                                พฤศจิกายน
                            </option>
                            <option value={12}>
                                ธันวาคม
                            </option>

                        </Input>
                        <div className='d-flex justify-content-center align-items-center w-50'>
                            <span className='header-select-year mx-3'>ค้างชำระปี</span>
                            <Input
                                // className='report-select-year'
                                className="rounded-pill input-color w-50 text-center"
                                id="othYear"
                                name="othYear"
                                type="select"
                                value={thYearSelected}
                            onChange={(e) => {
                                setThYearSelected(e.target.value)
                            }}
                            >
                                {Re1910yeardata.map((item, i) => (
                                    <option value={item.yearTh}>
                                        {Number(item.budgetYear)+543}
                                    </option>

                                ))}

                            </Input>
                        </div>
                    </div>
                </div>



                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1910?thMonth=${thMonthSelected}&thYear=${thYearSelected}`} download><RiFileExcel2Line /> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1910?thMonth=${thMonthSelected}&thYear=${thYearSelected}`} download><AiOutlineFilePdf /> Export PDF</Button>
                    </Col>
                </Row>

                <div className="report-wrapper">
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th rowSpan="3">
                                    ลำดับ
                                </th>
                                <th rowSpan="3">
                                    ผู้กู้ยืม
                                </th>
                                <th rowSpan="3">
                                    วงเงินกู้ยืม
                                </th>
                                <th rowSpan="3">
                                    อัตราดอกเบี้ย
                                </th>
                                <th rowSpan="3">
                                    ผ่อนชำระ (งวด)
                                </th>
                                <th rowSpan="3">
                                    งวดละ (บาท)
                                </th>
                                <th rowSpan="3">
                                    วันที่เริ่มชำระ
                                </th>
                                <th rowSpan="3">
                                    ผ่อนผัน (6 เดือน)
                                </th>
                                <th rowSpan="3">
                                    สิ้นสุดชำระ
                                </th>
                                <th colSpan="5" className=' text-center'>
                                    จำนวนเงินชำระคืน
                                </th>
                                <th colSpan="4" className=' text-center'>
                                    ค้างชำระ เดือน {monthTh}
                                </th>
                                <th rowSpan="3">
                                    เงินต้นคงเหลือ
                                </th>
                                <th rowSpan="3">
                                    หน่วยงานที่ทำสัญญา
                                </th>

                            </tr>
                            <tr>
                                <th rowSpan="2" className='text-center'>
                                    จำนวน (งวด)
                                </th>
                                <th colSpan="4" className=' text-center'>
                                    จำนวน (เงิน)
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    จำนวน (งวด)
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    จำนวน (เงิน)
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    เงินต้น
                                </th>
                                <th className='text-center'>
                                    ดอกเบี้ย
                                </th>
                                <th className='text-center'>
                                    รวม
                                </th>
                                <th className='text-center'>
                                    วันที่ชำระครั้งสุดท้าย
                                </th>
                                <th className='text-center'>
                                    เงินต้น
                                </th>
                                <th className='text-center'>
                                    ดอกเบี้ย
                                </th>
                                <th className='text-center'>
                                    รวม
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Borrow1910data.map((item, i) => (
                                <tr key={i}>
                                    <th scope="row" className='text-center'>
                                        {i + 1}
                                    </th>
                                    <td className='text-start'>
                                        {item.employee}
                                    </td>
                                    <td className='text-end'>
                                        {item.amountLimit}
                                    </td>
                                    <td className='text-end'>
                                        {item.interest}
                                    </td>
                                    <td className='text-end'>
                                        {item.installment}
                                    </td>
                                    <td className='text-end'>
                                        {item.installmentAmount}
                                    </td>
                                    <td className='text-end'>
                                        {item.firstPaymentDate}
                                    </td>
                                    <td className='text-end'>
                                        {item.lenient}
                                    </td>
                                    <td className='text-end'>
                                        {item.typeLastPayment}
                                    </td>
                                    <td className='text-end'>
                                        {item.paymentAmount}
                                    </td>
                                    <td className='text-end'>
                                        {item.repayPrincipal}
                                    </td>
                                    <td className='text-end'>
                                        {item.repayInterest}
                                    </td>
                                    <td className='text-end'>
                                        {item.totalRepay}
                                    </td>
                                    <td className='text-end'>
                                        {item.lastPaymentDate}
                                    </td>
                                    <td className='text-end'>
                                        {item.overdueAmount}
                                    </td>
                                    <td className='text-end'>
                                        {item.overduePrincipal}
                                    </td>
                                    <td className='text-end'>
                                        {item.overdueInterest}
                                    </td>
                                    <td className='text-end'>
                                        {item.totalOverdue}
                                    </td>
                                    <td className='text-end'>
                                        {item.totalPrincipal}
                                    </td>
                                    <td className='text-end'>
                                        {item.site}
                                    </td>

                                </tr>))}
                        </tbody>
                    </Table>
                </div>


            </div>

        </Container>
    );
}